export const CHECKMARK_PATH_STYLES = '[&>path]:fill-green-600 [&>path]:stroke-green-600 [&>path]:stroke-[0.5]';
